<template>
  <b-container fluid class="vh-100 m-0 p-0" :class="[{ 'show-wide': showWide }, `mq-${$mq}`]">
    <b-row class="minh-100 no-gutters">
      <AppSidebar />
      <main class="main-view vh-100 col" :class="{ 'main-view--wide': showWide }">
        <router-view />
      </main>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import AppSidebar from '@/components/shared/sidebar';

export default {
  name: 'ApplicationLayout',
  components: { AppSidebar },
  data() {
    return {
      drawer: null
    };
  },
  computed: {
    ...mapState(['loading']),
    showWide() {
      return this.$route.meta.showWide || this.$mq === 'sm';
    }
  }
};
</script>
